import { ref, onMounted } from '@vue/composition-api'
import store from '@/store'

export default function useEventsList() {
  const eventsList = ref([])
  const FetchEvents = () => {
    eventsList.value = []
    store
      .dispatch('events/apiCall', {
        mode: 'Select',
        request: {
          all: process.env.VUE_APP_API_ALL,
          srt: 'name',
          desc: false,
        },
      })
      .then(response => {
        if (response.success) {
          eventsList.value = response.data.items
        }
      })
  }
  onMounted(() => {
    FetchEvents()
  })

  return {
    eventsList,
  }
}
